module.exports = __webpack_public_path__ + "img/move-bg.71207c4a.jpg";